import type { IconData } from '@stacksjs/iconify-core'

export const manArmRaises2AlternateFlat: IconData = {
  "body": "<g fill=\"#8fbffa\"><path d=\"M24 1.5a6.5 6.5 0 1 1 0 13a6.5 6.5 0 0 1 0-13\"/><path d=\"M4.351 14.015c.463-1.229 1.814-1.826 3.037-1.432l9.174 2.959a9.5 9.5 0 0 0 2.916.458h9.046a9.5 9.5 0 0 0 2.915-.459l9.173-2.958c1.224-.394 2.574.203 3.037 1.432c.418 1.11.722 2.064.934 2.796c.335 1.158-.278 2.323-1.345 2.796l-10.65 4.722l-.519 18.715c-.046 1.668-1.273 3.099-2.966 3.274a36 36 0 0 1-2.138.16a1.466 1.466 0 0 1-1.519-1.392l-.64-11.115a.5.5 0 0 0-.5-.471h-.612a.5.5 0 0 0-.5.471l-.64 11.115a1.466 1.466 0 0 1-1.519 1.392a36 36 0 0 1-2.136-.16c-1.694-.175-2.92-1.606-2.966-3.274l-.518-18.715l-10.653-4.723c-1.066-.472-1.68-1.637-1.345-2.796a38 38 0 0 1 .934-2.795\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default manArmRaises2AlternateFlat
